import SettingsTabBase from "./SettingsTabBase.jsx";
import {
  NOTIFY_PREFS_TYPES_TEXT,
  NOTIFICATIONS_BANNERS_PREF_NAMES, SETTING_TAB_WIDGET_KEYS
} from "../../../other/constants/OtherKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { assignViewsState } from "../../../other/utils/otherUtils.jsx";

export default class SwivuAlertNotifications extends SettingsTabBase {
  static get $name() {
    return "SwivuAlertNotifications";
  }

  static get type() {
    return "swivualertnotifications";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.alertNotifications;
  }

  static get configurable() {
    return {
      title: "Notifications",
      scrollable: false,
      items: {
        alertNotificationsTypeGrid: {
          type: WIDGET_KEYS.swivuGrid,
          cls: "h-full",
          minHeight: "30em",
          features: {
            filter: false,
            cellMenu: false,
            stripe: { disabled: true },
            group: false,
            sort: false,
            rowReorder: { showGrip: true }
          },
          columns: [
            {
              id: "notifyType",
              text: "Notify Type",
              field: "notifyType",
              flex: 1,
              editor: false,
              renderer: ({ value }) => {
                return NOTIFY_PREFS_TYPES_TEXT[value];
              }
            },
            {
              id: "isEmailNotify",
              text: "Email",
              field: "isEmailNotify",
              type: "check",
              flex: 1,
            },
            {
              id: "bannerNotify",
              text: "Board Banners",
              type: "widget",
              flex: 1,
              editable: false,
              field: "bannerNotify",
              widgets: [],
            },
            {
              id: "isWorkforceNotify",
              text: "Workforce App",
              field: "isWorkforceNotify",
              type: "check",
              flex: 1,
            },
            {
              id: "interupt",
              text: "Interupt",
              field: "interupt",
              type: "check",
              flex: 1,
            }
          ],
        },
      },
    }
  }

  getStoreName() {
    return STORE_KEYS.notifyPreferenceStore
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);

    const { alertNotificationsTypeGrid } = this.widgetMap;
    const store = context.project.getCrudStore(this.getStoreName());
    const isBannerNotify = alertNotificationsTypeGrid.columns.getById("bannerNotify");
    isBannerNotify.widgets = this.getIsBannerNotifyWidget();
    alertNotificationsTypeGrid.stateId = PERSISTENCE_STATE_KEYS.personalSettingAlertsGridState;
    assignViewsState([alertNotificationsTypeGrid], context.stateProvider);
    alertNotificationsTypeGrid.store = store;
  }

  getIsBannerNotifyWidget() {
    return [{
      name: "bannerNotify",
      type: "combo",
      displayField: "name",
      valueField: "id",
      items: NOTIFICATIONS_BANNERS_PREF_NAMES.map(({id, name}) => ({id, name})),
      cls: "swivu-user-role-combo [&_input]:!pl-0",
      width: "100%",
    }]
  }
}

SwivuAlertNotifications.initClass();
